import React, { Fragment } from 'react';


const FooterModel = ({ data }) => {
    if (!data) return <div>Loading...</div>;

    const {
        footer_logo,
        about_text,
        social_links,
        quick_links,
        service_links,
        contact,
        copyright
    } = data.footer_param;

    const { bg_checked, bg_image, bg_color, text_color, text_color_hover } = data;

    // Style dynamique pour le footer
    const footerStyle = {
        color: text_color || '#fff',
        ...(bg_checked === 'bg_image' && data?.footer_bg_image_url
            ? {
                backgroundImage: `url(${data.footer_bg_image_url})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
            }
            : bg_checked === 'bg_color'
                ? { backgroundColor: bg_color || '#000' }
                : {})
    };

    return (
        <Fragment>
            {/* Style hover dynamique */}
            {text_color_hover && (
                <style>{`
                    .main-footer *:hover {
                        color: ${text_color_hover} !important;
                    }
                `}</style>
            )}

            <footer className="main-footer" style={footerStyle}>
                <div className="container">
                    <div className="row">
                        {/* About */}
                        <div className="col-lg-4">
                            <div className="about-footer">
                                <div className="footer-logo">
                                    <img src={footer_logo?.src} alt={footer_logo?.alt} height="64px" />
                                </div>
                                <div className="about-footer-content">
                                    <p>{about_text}</p>
                                </div>
                                <div className="footer-social-links">
                                    <ul>
                                        {social_links?.map((link, index) => (
                                            <li key={index}>
                                                <a href={link.url}>
                                                    <i className={link.icon}></i>
                                                </a>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>

                        {/* Quick Links */}
                        <div className="col-lg-2 col-md-3 col-6">
                            <div className="footer-links">
                                <h3>{quick_links?.title}</h3>
                                <ul>
                                    {quick_links?.links?.map((item, index) => (
                                        <li key={index}>
                                            <a href={item.url}>{item.label}</a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>

                        {/* Service Links */}
                        <div className="col-lg-3 col-md-4 col-6">
                            <div className="footer-links">
                                <h3>{service_links?.title}</h3>
                                <ul>
                                    {service_links?.links?.map((item, index) => (
                                        <li key={index}>
                                            <a href={item.url}>{item.label}</a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>

                        {/* ContactPage */}
                        <div className="col-lg-3 col-md-5">
                            <div className="footer-contact">
                                <h3>{contact?.title}</h3>
                                <div className="footer-contact-details">
                                    {contact?.details?.map((item, index) => (
                                        <div key={index} className="footer-info-box">
                                            <div className="icon-box">
                                                <i className={item.icon}></i>
                                            </div>
                                            <div className="footer-info-box-content">
                                                <p>{item.value}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Copyright */}
                    <div className="footer-copyright">
                        <div className="row align-items-center">
                            <div className="col-lg-6 col-md-6">
                                <p>{copyright?.text}</p>
                            </div>
                            <div className="col-lg-6 col-md-6">
                                <ul>
                                    {copyright?.links?.map((link, index) => (
                                        <li key={index}>
                                            <a href={link.url}>{link.label}</a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </Fragment>
    );
};


export default FooterModel;
